import PaCartManager from './js/cart_manager.js';
import { minimumPrice } from './js/pricing.js';
import PaCartCompat from './js/cart_compat.js';
import PaSubscriptionCards from './js/subscription_cards.js';
import PaStickyBasket from './js/sticky_basket.js';
// Frontend skins. Imported here (not in any block's style.scss) so they ship
// in dist/frontend.css, which loads after style-blocks.css and therefore wins
// the cascade against Bulma and the legacy block styles at equal specificity.
import './js/subscription_select.scss';
import './js/channel_logos.scss';
import './js/basket_page.scss';
import './js/invoices_table.scss';
import './js/overview_page.scss';
import './js/profile_cards.scss';
import './js/cardpay_page.scss';
import './js/network_pages.scss';
import './js/login_page.scss';
import './js/conax_cards.scss';
import './js/signup_input.scss';
import './js/mitid.scss';
import './js/mix_config.scss';
import './js/mobile_order.scss';
import './js/allente_version_1.scss';
//state_colors.scss is NOT imported here: it builds into its own always-on
//stylesheet (dist/state-colors.css, see build:state-colors) because its
//classes are functional feedback, not skin — see the note in that file.

jQuery( document ).ready( function() {
    // Cart UX: badge/count sync, subscription card button state, sticky basket bar.
    // Frontend only — in the Elementor frontend editor these would mutate
    // React-managed block previews and crash the editor. This is the ONLY
    // editor context this bundle can load in: wp-admin/block-editor pages
    // never enqueue frontend-js (the is_admin() guard in init.php).
    const isEditorContext = document.body && document.body.classList.contains( 'elementor-editor-active' );
    if ( ! isEditorContext ) {
        PaCartCompat.init();
        PaCartManager.init();
        PaSubscriptionCards.init();
        PaStickyBasket.init();
    }

    if ( localStorage.getItem( 'customertoken' ) == null ) {
        jQuery( "#menu-item-" + JQUERY_VARS.customerInfoPage.menu_item_id ).css( 'display', 'none' );
        jQuery( "#menu-item-" + JQUERY_VARS.customerInvoicesPage.menu_item_id ).css( 'display', 'none' );
        jQuery( "#menu-item-" + JQUERY_VARS.customerProductsPage.menu_item_id ).css( 'display', 'none' );
        jQuery( "#menu-item-" + JQUERY_VARS.customerCommunicationPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".menu-item-" + JQUERY_VARS.customerInfoPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".menu-item-" + JQUERY_VARS.customerInvoicesPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".menu-item-" + JQUERY_VARS.customerProductsPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".menu-item-" + JQUERY_VARS.customerCommunicationPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".page-item-" + JQUERY_VARS.customerInfoPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".page-item-" + JQUERY_VARS.customerInvoicesPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".page-item-" + JQUERY_VARS.customerProductsPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".page-item-" + JQUERY_VARS.customerCommunicationPage.menu_item_id ).css( 'display', 'none' );
        if ( JQUERY_VARS.additionalMenuItems != null ) {
            const additionalMenuItems = JQUERY_VARS.additionalMenuItems.split( ',' );
            additionalMenuItems.forEach( item => {
                jQuery( "#menu-item-" + item.trim() ).css( 'display', 'none' );
                jQuery( ".menu-item-" + item.trim() ).css( 'display', 'none' );
                jQuery( ".page-item-" + item.trim() ).css( 'display', 'none' );
            } );
        }
        // Hide logout triggers when nobody is logged in. For links inside a
        // menu, hide the whole menu item so no empty <li> remains.
        jQuery( '.pa-logout, a[href$="#pa-logout"]' ).each( function() {
            const menuItem = jQuery( this ).closest( 'li' );
            ( menuItem.length ? menuItem : jQuery( this ) ).css( 'display', 'none' );
        } );
    } else {
        jQuery( "#menu-item-" + JQUERY_VARS.loginPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".menu-item-" + JQUERY_VARS.loginPage.menu_item_id ).css( 'display', 'none' );
        jQuery( ".page-item-" + JQUERY_VARS.loginPage.menu_item_id ).css( 'display', 'none' );
    }

    // Designer-facing logout hook: any element with the pa-logout class, or
    // any link pointing at #pa-logout, logs the customer out. Lets designers
    // add logout to menus (Custom Link with URL "#pa-logout", or the CSS
    // Classes field), buttons and plain links without touching the plugin.
    // Delegated so it also catches markup rendered after page load.
    jQuery( document ).on( 'click', '.pa-logout, a[href$="#pa-logout"]', function( e ) {
        e.preventDefault();
        paLogout();
    } );

    //goToLogin: the window.goToLogin global defined below — the module body
    //has run by the time this ready-callback executes (a local duplicate of
    //the same three lines used to live here).
    function isLoggedIn() {
        if ( localStorage.getItem( 'customertoken' ) == null ) {
            sessionStorage.clear();
            localStorage.clear();
            goToLogin();
        }
        if ( localStorage.getItem( 'customertoken' ) != null && localStorage.getItem( 'tokenExpire' ) <= Math.floor( Date.now() / 1000 ) ) {
            sessionStorage.clear();
            localStorage.clear();
            goToLogin();
        }
    }

    window.notifySuccess = function notifySuccess( text ) {
        alertify.set( 'notifier', 'position', 'top-center' );
        alertify.notify( text, 'success', 10, function() { } );
    };

    window.notifyError = function notifyError( text ) {
        alertify.set( 'notifier', 'position', 'top-center' );
        alertify.notify( text, 'error', 10, function() { } );
    };

    if ( jQuery( "#login_form" ).length ) {
        import( './js/login.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#customer-info-container" ).length ) {
        isLoggedIn();
        import( './js/customerinfo.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#cardpay_container" ).length ) {
        isLoggedIn();
        import( './js/cardpay.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#invoice_container" ).length ) {
        isLoggedIn();
        import( './js/invoices.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#product_container" ).length ) {
        isLoggedIn();
        import( './js/products.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#bullguard_container" ).length ) {
        isLoggedIn();
        import( './js/bullguard.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#fsecure_container" ).length ) {
        isLoggedIn();
        import( './js/f_secure.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".addon_product_container" ).length ) {
        isLoggedIn();
        import( './js/addon_products.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#tickets-container" ).length ) {
        isLoggedIn();
        import( './js/tickets.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".order_progress_container" ).length ) {
        isLoggedIn();
        import( './js/ordreprogress.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#internet-info-container" ).length ) {
        isLoggedIn();
        import( './js/internet.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#telecom-container" ).length ) {
        isLoggedIn();
        import( './js/telecom.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#pa-mobile-subscription-container" ).length ) {
        isLoggedIn();
        import( './js/mobile_subscription.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#modem-data-container" ).length ) {
        isLoggedIn();
        import( './js/modemdata.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#technician-container" ).length ) {
        isLoggedIn();
        import( './js/technician.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#wifi-data-container" ).length ) {
        isLoggedIn();
        import( './js/live_wifi.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".pa-my-overview" ).length ) {
        isLoggedIn();
        import( './js/myoverview.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".allente_tv_container" ).length ) {
        isLoggedIn();
        import( './js/allente.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#socialConnection-container" ).length ) {
        isLoggedIn();
        import( './js/attach_social_login.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".subscription-container" ).length ) {
        isLoggedIn();
        import( './js/subscription.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#pa-calendar-container-Opstart" ).length ) {
        import( './js/pa-calendar.js' )
            .then( ( module ) => {
                module.init( 'Opstart' );
                //Fristen kan afhaenge af hvad kunden vaelger - et eSIM kan
                //oprettes med det samme. Kalenderen er en selvstaendig blok og
                //kan ikke vide det, saa den udstiller en krog i stedet.
                window.paCalendarRebuild = module.rebuild;
            } );
    }

    if ( jQuery( "#pa-calendar-container-Opsigelse" ).length ) {
        isLoggedIn();
        import( './js/pa-calendar.js' )
            .then( ( module ) => {
                module.init( 'Opsigelse' );
            } );
    }

    if ( jQuery( "#pa-calendar-container-Opgradering" ).length ) {
        isLoggedIn();
        import( './js/pa-calendar.js' )
            .then( ( module ) => {
                module.init( 'Opgradering' );
            } );
    }

    if ( jQuery( "#pa-calendar-container-Nedgradering" ).length ) {
        isLoggedIn();
        import( './js/pa-calendar.js' )
            .then( ( module ) => {
                module.init( 'Nedgradering' );
            } );
    }

    if ( jQuery( ".cancel-product-container" ).length ) {
        isLoggedIn();
        import( './js/cancel.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( "#pa-dawa-container" ).length ) {
        import( './js/dawa_block.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".signupinput" ).length ) {
        import( './js/signup_input.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".signup-page-break" ).length ) {
        import( './js/signup_page_change.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    //Mobilbestilling er opt-in pr. installation. Er flaget slået fra, loader vi
    //ikke modulet OG rydder en evt. efterladt nøgle: submitSignup() fejer alle
    //pa_*-nøgler med i ordren, og pa_* ryddes ellers kun ved adresseskift — så
    //uden dette kunne en kunde med en åben fane submitte en mobilordre efter at
    //flowet var slået fra.
    if ( jQuery( "#pa-mobile-order-container" ).length ) {
        if ( JQUERY_VARS.mobileOrder && JQUERY_VARS.mobileOrder.enabled ) {
            import( './js/mobile_order.js' )
                .then( ( module ) => {
                    module.init();
                } );
        } else {
            sessionStorage.removeItem( 'pa_mobilordre' );
        }
    }

    //Produktfilter-bjaelken paa trin 2: skjules naar der ikke er noget at
    //filtrere. Tenantens eget script skjuler de tomme faner, men ikke bjaelken.
    if ( jQuery( '#pa-step2-product-controls' ).length ) {
        import( './js/step2_filter_bar.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    //MitID-bekraeftelse. Indlaeses ogsaa naar der IKKE er en mobilblok paa
    //siden: retursiden fra Criipto er en anden side, og den skal kunne
    //haandtere svaret i sit fragment.
    if ( JQUERY_VARS.mitid && JQUERY_VARS.mitid.enabled ) {
        import( './js/mitid.js' )
            .then( ( module ) => {
                module.init();
            } );
    } else {
        //Slaas flaget fra, maa en godkendelse fra en aaben fane ikke kunne
        //foelge med i ordren. Samme princip som pa_mobilordre ovenfor.
        sessionStorage.removeItem( 'pa_mitiduuid' );
    }

    if ( jQuery( ".conax-container-multipackets" ).length || jQuery( ".conax-container-singlepackets" ).length || jQuery( ".conax-container-eventpackets" ).length || jQuery( ".conax-container-mixpackets" ).length ) {
        isLoggedIn();
        import( './js/conax_block.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".subscription-select-container" ).length ) {
        isLoggedIn();
        import( './js/subscription_select.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".mix-container" ).length ) {
        isLoggedIn();
        import( './js/mix_config_block.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".allente-version-1-container" ).length ) {
        isLoggedIn();
        import( './js/allente_version_1.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".basket-container" ).length ) {
        isLoggedIn();
        import( './js/basket.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".sbbu-container" ).length ) {
        isLoggedIn();
        import( './js/sbbu.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".overview-container" ).length ) {
        isLoggedIn();
        import( './js/overview_block.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    //webtv-container
    if ( jQuery( ".webtv-container" ).length ) {
        isLoggedIn();
        import( './js/webtv.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    if ( jQuery( ".allente-container" ).length ) {
        isLoggedIn();
        import( './js/allente_block.js' )
            .then( ( module ) => {
                module.init();
            } );
    }

    // Check for error messages in the url
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );
    if ( urlParams.get( "e" ) ) {
        window.parent.notifyError( urlParams.get( "e" ) );
    }
    if ( urlParams.get( "success" ) ) {
        window.parent.notifySuccess( urlParams.get( "success" ) );
    }

    // Email management block
    if ( jQuery( ".email-container" ).length ) {
        isLoggedIn();
        import( './js/email.js' )
            .then( ( module ) => {
                module.init();
            } );
    }
}
);

window.validText = function validText( theText, errorMessage, regex ) {
    if ( ! regex.length ) {
        return true;
    }

    const validRegex = new RegExp( regex );

    if ( ! validRegex.test( theText ) ) {
        window.parent.notifyError( errorMessage );
        return false;
    } return true;
};

window.getProductName = function getProductName( product ) {
    if ( ! product ) {
        return '';
    }
    const da = product.selfserviceNames?.da ?? product.productConf?.selfserviceNames?.da;
    return ( da && String( da ).trim() ) ? da : ( product.name || '' );
};

//Rekursivt gennemløb af en værdi, hvor strenge der indeholder JSON (objekt eller
//array) parses til rigtige objekter. Bruges af flere blokke til at pakke produkter
//ud af sessionStorage, hvor felter kan være dobbelt-serialiseret.
window.parseJsonFields = function parseJsonFields( value ) {
    if ( typeof value === 'string' ) {
        const trimmed = value.trim();
        // Kun forsøg at parse strenge der ligner et JSON-objekt eller -array,
        // så simple strenge/tal ikke fejlagtigt konverteres.
        if ( trimmed.startsWith( '{' ) || trimmed.startsWith( '[' ) ) {
            try {
                // Parse og gennemløb resultatet igen - der kan ligge JSON
                // på et dybere niveau.
                return parseJsonFields( JSON.parse( trimmed ) );
            } catch ( e ) {
                // Ikke gyldig JSON - behold den oprindelige streng.
            }
        }
        return value;
    }

    if ( Array.isArray( value ) ) {
        return value.map( ( item ) => parseJsonFields( item ) );
    }

    if ( value !== null && typeof value === 'object' ) {
        const result = {};
        for ( const key in value ) {
            result[ key ] = parseJsonFields( value[ key ] );
        }
        return result;
    }

    return value;
};

//Erstat {pladsholdere} i en præsentations-skabelon med værdier. Faste aliaser sendes
//med i `aliases` (fx {n}, {s}, {f}, {k}); alle øvrige {felt.sti} slås op direkte på
//item'et via punktnotation. Ukendte pladsholdere bliver til en tom streng.
//Delt mellem subscription_select.js og signup_input.js.
window.renderPlaceholders = function renderPlaceholders( presentation, item, aliases = {} ) {
    const resolvePath = function( obj, path ) {
        let current = obj;
        for ( const key of path.split( '.' ) ) {
            if ( current === null || current === undefined ) {
                return undefined;
            }
            current = current[ key ];
        }
        return current;
    };

    return presentation.replace( /\{([^{}]+)\}/g, function( match, token ) {
        if ( Object.prototype.hasOwnProperty.call( aliases, token ) ) {
            return aliases[ token ];
        }

        const value = resolvePath( item, token );
        if ( value === null || value === undefined ) {
            return '';
        }
        return String( value );
    } );
};

window.addNonce = function addNonce( url ) {
    const appendChar = url.includes( '?' ) ? '&' : '?';
    return url + appendChar + '_wpnonce=' + JQUERY_VARS.nonce;
};

window.goToLogin = function goToLogin() {
    window.location.replace( JQUERY_VARS.siteUrl + '/' + JQUERY_VARS.loginPage.page + '/' );
};

// Full logout: expire the customer token server-side, then clear local
// state and go to the login page. Local logout must happen even if the
// API call fails. Used by the profile-page logout button and by the
// site-wide .pa-logout / #pa-logout designer hook (see readme).
window.paLogout = function paLogout() {
    const finishLogout = function() {
        sessionStorage.clear();
        localStorage.clear();
        goToLogin();
    };
    if ( localStorage.getItem( 'customertoken' ) ) {
        makeApiRequest( 'POST', '/logout', null, finishLogout, finishLogout );
    } else {
        finishLogout();
    }
};

//Helper for the following functions
window.getBasket = function getBasket() {
    let b = false;

    try {
        b = JSON.parse( sessionStorage.getItem( "pa_basket" ) ); 
    } catch ( err ) { }

    return b;
};

/**
 * action: { 'add' | 'remove' | 'update'| 'upgrade' | 'downgrade' | 'config' }
 * @param  productConfID
 * @param  provModel
 * @param  action
 * @param  quantity
 * @param  actionDate
 * @return {boolean} true when the basket was written; false when the add was
 *                   refused (dependency check, missing catalog entry). NO
 *                   pa_basket_update fires on false — callers must not mark
 *                   their card selected.
 */
window.addToBasket = function addToBasket( productConfID, provModel, action, quantity = 1, actionDate = 0 ) {
    let basket = getBasket();
    const ap = JSON.parse( sessionStorage.getItem( 'pa_availableProducts' ) );
    const parameterStr = "";
    const customerProductIds = JSON.parse( sessionStorage.getItem( 'pa_customerProductIds' ) );
    const customerChannelIds = JSON.parse( sessionStorage.getItem( 'pa_customerChannelIds' ) );
        
    if ( ! allowAdd( productConfID, { ...customerProductIds, ...customerChannelIds } ) ) {
        window.parent.notifyError( 'Produktet kan ikke bestilles. Det kræver andre aktive produkter.' );
        return false;
    }

    //This could be the first item added
    if ( ! basket ) {
        basket = []; 
    }

    //Increase quantity if item already exists
    for ( const i in basket ) {
        if ( basket[ i ].id == productConfID ) {
            basket[ i ].quantity += quantity;
            sessionStorage.setItem( "pa_basket", JSON.stringify( basket ) );
            window.dispatchEvent( new Event( 'pa_basket_update' ) );
            return true;
        }
    }

    //Create and add item if it does not exist
    const pconf = ap && ap[ productConfID ];
    if ( ! pconf ) {
        //pa_availableProducts is missing (e.g. deep link into the page) — fail
        //with a message instead of throwing inside the click handler.
        window.parent.notifyError( 'Produktet kan ikke bestilles lige nu. Genindlæs siden og prøv igen.' );
        return false;
    }
    const aDate = ! actionDate ? Math.round( Date.now() / 1000 ) : Math.round( actionDate / 1000 );
    //Mindsteprisen regnes her, hvor produktet er kendt, og foelger med
    //ordren til PantherAdmin. Regnes den foerst ved behandlingen, kan
    //kataloget have skiftet, og saa staar der et andet tal end det kunden
    //sagde ja til. commitmentMonths er den binding tallet bygger paa - uden
    //den kan beloebet ikke efterproeves bagefter.
    const mindste = minimumPrice( pconf );
    const item = { id: productConfID, ident: pconf.ident, name: getProductName( pconf ), quantity, provModel, parameters: parameterStr, action, actionDate: aDate, priceMinimum: mindste.total, commitmentMonths: mindste.months };
    basket.push( item );
    sessionStorage.setItem( "pa_basket", JSON.stringify( basket ) );
    window.dispatchEvent( new Event( 'pa_basket_update' ) );
    return true;
};

/**
 * Hard push to basket
 * item is a correctly formatted basket item
 * @param item
 */
window.pushToBasket = function pushToBasket( item ) {
    let basket = getBasket();
    if ( ! basket ) {
        basket = []; 
    }
    basket.push( item );
    sessionStorage.setItem( "pa_basket", JSON.stringify( basket ) );
    window.dispatchEvent( new Event( 'pa_basket_update' ) );
};

window.removeFromBasket = function removeFromBasket( productConfID, provModel = "", quantity = 1, action = "" ) {
    const basket = getBasket();
    if ( ! Array.isArray( basket ) ) {
        return false;
    }

    //Refuse to remove an add/upgrade/downgrade selection that another basket
    //selection depends on — the dependent must be removed first. remove/config
    //lines are cancellations/edits of owned products, not selections, and are
    //never blocked here. This guards every remove path, incl. the cart page.
    const owned = {
        ...( JSON.parse( sessionStorage.getItem( 'pa_customerProductIds' ) ) || {} ),
        ...( JSON.parse( sessionStorage.getItem( 'pa_customerChannelIds' ) ) || {} ),
    };
    for ( const line of basket ) {
        if ( ! line ) {
            continue;
        }
        const targeted = ( provModel != "" && line.provModel == provModel && ( action == "" || line.action == action ) ) ||
            line.id == productConfID;
        if ( ! targeted ) {
            continue;
        }
        if ( ( line.action === 'add' || line.action === 'upgrade' || line.action === 'downgrade' ) &&
            ! allowRemove( line.id, owned ) ) {
            window.parent.notifyError( 'Produktet kan ikke fjernes. Det kræves af et andet produkt i kurven.' );
            return false;
        }
    }

    let touched = false;
    for ( const line of basket ) {
        if ( ! line ) {
            continue;
        }
        //The default call form removeFromBasket(id) matches by id only; the
        //provModel form matches lines of that provisioning model, optionally
        //narrowed by action (previously a passed action matched EVERY line
        //with that action, across provisioning models).
        const explicitMatch = provModel != "" && line.provModel == provModel &&
            ( action == "" || line.action == action );
        if ( explicitMatch || line.id == productConfID ) {
            line.quantity -= quantity;
            touched = true;
        }
    }
    if ( ! touched ) {
        //Nothing matched — no write, no event.
        return false;
    }

    //Drop emptied lines in a second pass — splicing inside the loop above
    //skips the element that shifts into the removed slot.
    const remaining = basket.filter( line => line && line.quantity > 0 );

    sessionStorage.setItem( "pa_basket", JSON.stringify( remaining ) );
    window.dispatchEvent( new Event( 'pa_basket_update' ) );
    return true;
};

/**
 * Drops every matching line outright and writes once. Returns the dropped lines.
 *
 * removeFromBasket() subtracts one from the quantity instead, which is right for
 * a thing you can have several of and wrong for a selection: a line that had
 * been added twice survives the "removal" with quantity 1, still in the basket
 * while its card shows unselected. Selecting is not counting.
 *
 * @param matches
 */
window.dropSelections = function dropSelections( matches ) {
    const before = getBasket() || [];
    const dropped = before.filter( ( line ) => line && matches( line ) );
    if ( ! dropped.length ) {
        return dropped;
    }
    const kept = before.filter( ( line ) => line && ! matches( line ) );
    sessionStorage.setItem( "pa_basket", JSON.stringify( kept ) );
    window.dispatchEvent( new Event( 'pa_basket_update' ) );
    return dropped;
};

window.clearBasket = function clearBasket() {
    sessionStorage.removeItem( "pa_basket" );
    window.dispatchEvent( new Event( 'pa_basket_update' ) );
};

window.submitBasket = function submitBasket( redirect ) {
    if ( ! checkConditions() ) {
        return false;
    }

    //In case a mix packet has been ordered or configured
    //The selection is finalized here
    saveSelectedMixChannels();
    //return;
    makeApiRequest(
        'POST',
        '/customer/order',
        sessionStorage.getItem( "pa_basket" ),
        function( data ) {
            sessionStorage.removeItem( "pa_basket" );
            sessionStorage.removeItem( "pa_selectedSlugs" );
            //Badge/sticky bar must not show the old count between the POST
            //and the navigation (and a missing redirect must not land the
            //customer on ".../undefined").
            window.dispatchEvent( new Event( 'pa_basket_update' ) );
            if ( redirect ) {
                window.location.replace( redirect );
            } else {
                window.location.reload();
            }
        },
        function() {
            window.parent.notifyError( 'Bestilling fejlet.' );
        }
    );
};

window.findInBasket = function findInBasket( pcid, provModel = "" ) {
    const basket = getBasket();
    for ( const pos in basket ) {
        if ( provModel.length > 0 && basket[ pos ].provModel == provModel ) {
            return basket[ pos ];
        } else if ( basket[ pos ].id == pcid ) {
            return basket[ pos ];
        }
    }

    return null;
};

window.getPCIDFromString = function getPCIDFromString( str ) {
    let pcid = "";

    for ( const chr of str ) {
        if ( Number.isInteger( Number.parseInt( chr ) ) ) {
            pcid = pcid.concat( chr );
        }
    }

    return pcid;
};

//Product ids that count as active for dependency checks even before the order
//is submitted: a basket line with an add/upgrade/downgrade action makes its
//product count as active. remove/config actions do not.
function basketActiveIds() {
    const ids = {};
    const basket = getBasket() || [];
    for ( const line of basket ) {
        if ( line && ( line.action === 'add' || line.action === 'upgrade' || line.action === 'downgrade' ) ) {
            ids[ line.id ] = true;
        }
    }
    return ids;
}

window.allowAdd = function allowAdd( pcid, customerProducts, includeBasket = true ) {
    const requires = JSON.parse( sessionStorage.getItem( 'pa_requires' ) );

    if ( ! requires || ! Object.hasOwn( requires, pcid ) ) {
        return true;
    }

    //A required product also counts as satisfied when it has an add/upgrade/
    //downgrade action in the basket — not only when it is already active on the
    //customer. includeBasket is false only for allowRemove's recursive
    //"without pcid" probe, whose hypothesis set must not be re-augmented.
    const active = includeBasket ? { ...customerProducts, ...basketActiveIds() } : customerProducts;

    let requiredPresent = false;
    //Run through access giving combinations
    for ( const akey in requires[ pcid ] ) {
        requiredPresent = true;
        for ( const bkey in requires[ pcid ][ akey ] ) {
            if ( ! Object.hasOwn( active, requires[ pcid ][ akey ][ bkey ].id ) ) {
                requiredPresent = false;
                break;
            }
        }

        if ( requiredPresent ) {
            return true;
        }
    }

    return requiredPresent;
};

window.allowRemove = function allowRemove( pcid, customerProducts ) {
    const isRequired = JSON.parse( sessionStorage.getItem( 'pa_isrequired' ) );
    if ( ! isRequired ) {
        return true;
    }

    // Active set including basket add/upgrade/downgrade selections, so a product
    // that is only selected in the basket (not yet owned) still counts as a
    // dependent that can block removing pcid.
    const basketActive = basketActiveIds();
    const active = { ...customerProducts, ...basketActive };

    // The set that remains once this removal is applied, used to test whether a
    // dependent still has access.
    let withoutPcid;
    if ( Object.hasOwn( basketActive, pcid ) ) {
        // Removing pcid's basket selection: pcid stays present if the customer
        // still owns it independently (e.g. a channel delivered by a packet
        // they own), so a dependent satisfied that way is not affected. Only
        // the basket contribution is dropped.
        const remainingBasket = Object.assign( {}, basketActive );
        delete remainingBasket[ pcid ];
        withoutPcid = { ...customerProducts, ...remainingBasket };
    } else {
        // Cancelling an owned product: it — and the channels it provides — go.
        withoutPcid = Object.assign( {}, active );
        delete withoutPcid[ pcid ];
        for ( const k in active ) {
            if ( active[ k ] == pcid ) {
                delete withoutPcid[ k ];
            }
        }
    }

    // Do we have a product that requires this product?
    if ( Object.hasOwn( isRequired, pcid ) ) {
        for ( const akey in isRequired[ pcid ] ) {
            const dependentId = isRequired[ pcid ][ akey ].id;
            if ( Object.hasOwn( active, dependentId ) ) {
                // Would this dependent still have access without pcid? Probe the
                // hypothesis set directly (includeBasket=false) so the basket
                // does not re-add pcid.
                if ( ! allowAdd( dependentId, withoutPcid, false ) ) {
                    return false;
                }
            }
        }
    }

    // Do we have a product that requires this product's channels?
    for ( const i in active ) {
        if ( active[ i ] == pcid && Object.hasOwn( isRequired, i ) ) {
            for ( const n in isRequired[ i ] ) {
                const dependentId = isRequired[ i ][ n ].id;
                if ( Object.hasOwn( active, dependentId ) ) {
                    if ( ! allowAdd( dependentId, withoutPcid, false ) ) {
                        return false;
                    }
                }
            }
        }
    }

    return true;
};

window.getDefaultSelectedSlugs = function getDefaultSelectedSlugs( mixParameters ) {
    const slugs = new Object();
    const mixElements = mixParameters.split( ';' );
    const mixInfo = JSON.parse( sessionStorage.getItem( 'pa_mixCounter' ) );

    for ( const a in mixElements ) {
        const keyVal = mixElements[ a ].split( ':' );

        if ( ( keyVal[ 0 ] == 'packetmixmandatory' ) || ( keyVal[ 0 ] == 'defaultchannels' ) ) {
            const slugList = keyVal[ 1 ].split( ',' );
            const typeValue = ( keyVal[ 0 ] == 'packetmixmandatory' ) ? 'M' : 'D';
            for ( const b in slugList ) {
                slugs[ slugList[ b ] ] = typeValue;
            }
        }
    }

    return slugs;
};

window.setSelection = function setSelection( elementId, provModel, unSelectedClass, selectedClass, markedForRemoveClass ) {
    const customerProductIds = JSON.parse( sessionStorage.getItem( 'pa_customerProductIds' ) );
    const customerChannelIds = JSON.parse( sessionStorage.getItem( 'pa_customerChannelIds' ) );
    const pcid = getPCIDFromString( elementId );
    const itemInBasket = findInBasket( pcid );

    if ( itemInBasket == null && ! Object.hasOwn( customerProductIds, pcid ) ) {
        //A product not owned and event (add) not in the basket

        //Does this product require other products
        if ( ! allowAdd( pcid, { ...customerProductIds, ...customerChannelIds } ) ) {
            window.parent.notifyError( 'Produktet kan ikke bestilles. Det kræver andre aktive produkter.' );
            return false;
        }

        //Only mark the card when the basket was actually written — a failed
        //add fires no pa_basket_update, so nothing would repair the class.
        if ( addToBasket( pcid, provModel, 'add' ) === false ) {
            return false;
        }
        jQuery( "#" + elementId ).removeClass( unSelectedClass ).addClass( selectedClass );
    } else if ( itemInBasket == null && Object.hasOwn( customerProductIds, pcid ) ) {
        //A product owned and event (terminate) not in the basket

        //Is this product required by other products
        if ( ! allowRemove( pcid, { ...customerProductIds, ...customerChannelIds } ) ) {
            window.parent.notifyError( 'Produktet kan ikke afbestilles. Det kræves af andre aktive produkter.' );
            return false;
        }

        if ( addToBasket( pcid, provModel, 'remove' ) === false ) {
            return false;
        }
        jQuery( "#" + elementId ).removeClass( unSelectedClass ).addClass( markedForRemoveClass );
    } else {
        //An add or remove event is in the basket. removeFromBasket refuses to
        //drop an add-selection another basket selection depends on (and
        //notifies); only restyle the card when the line was actually removed.
        if ( removeFromBasket( pcid ) === false ) {
            return false;
        }
        if ( Object.hasOwn( customerProductIds, pcid ) ) {
            //Products is owned and the terminate event has been deleted
            jQuery( "#" + elementId ).removeClass( markedForRemoveClass ).addClass( unSelectedClass );
        } else {
            //Product is not owned and the add event has been deleted
            jQuery( "#" + elementId ).removeClass( selectedClass ).addClass( unSelectedClass );
        }
    }
};

//Sum the price of the currently active subscriptions of a product configuration.
//Mirrors accumulateSubs() in subscription_select.js (including the string/number
//tolerant -1 sentinel handling) so the basket can rank subscriptions against each
//other. Note: this compares the base subscription price, not any time limited discount.
window.getSubscriptionTotal = function getSubscriptionTotal( pconf ) {
    if ( ! pconf || ! pconf.subscriptions ) {
        return 0;
    }

    let total = 0;
    const now = new Date();
    for ( const n in pconf.subscriptions ) {
        const sub = pconf.subscriptions[ n ];
        const fromStamp = Number( sub.from );
        const toStamp = Number( sub.to );
        const from = fromStamp === -1 ? new Date( 0 ) : new Date( fromStamp * 1000 );
        const to = toStamp === -1 ? new Date( ( ( Date.now() / 1000 ) + 3600 * 24 * 365 ) * 1000 ) : new Date( toStamp * 1000 );

        if ( from <= now && to >= now ) {
            total += Number( sub.price || 0 );
        }
    }

    return total;
};

//Find the customer's currently active product matching a provisioning model and
//return its product configuration (preferring the richer one from availableProducts,
//since the customer product's own productConf may be trimmed). Returns null if the
//customer has no active product of that type.
window.getActiveCustomerProductConf = function getActiveCustomerProductConf( provModel ) {
    const customerProducts = JSON.parse( sessionStorage.getItem( 'pa_customerProducts' ) );
    const availableProducts = JSON.parse( sessionStorage.getItem( 'pa_availableProducts' ) );
    const now = new Date();

    for ( const i in customerProducts ) {
        const cp = customerProducts[ i ];
        if ( ! cp.productConf || cp.productConf.provisioningModel !== provModel ) {
            continue;
        }

        //Same active check as login.isActive()
        if ( cp.startDate === null || new Date( cp.startDate ) > now ) {
            continue;
        }
        if ( cp.endDate !== null && new Date( cp.endDate ) < now ) {
            continue;
        }

        if ( availableProducts && availableProducts[ cp.productConf.id ] ) {
            return availableProducts[ cp.productConf.id ];
        }
        return cp.productConf;
    }

    return null;
};

//Decide whether adding a product is a plain 'add', or an 'upgrade'/'downgrade'
//relative to the customer's active product of the same provisioning model.
//No active product of that type stays 'add'. An equal subscription price counts
//as an 'upgrade'.
window.resolveSubscriptionAction = function resolveSubscriptionAction( pcid, provModel ) {
    const activeConf = getActiveCustomerProductConf( provModel );
    if ( activeConf === null ) {
        return 'add';
    }

    const availableProducts = JSON.parse( sessionStorage.getItem( 'pa_availableProducts' ) );
    const newConf = availableProducts ? availableProducts[ pcid ] : null;

    const newSub = getSubscriptionTotal( newConf );
    const activeSub = getSubscriptionTotal( activeConf );

    return newSub < activeSub ? 'downgrade' : 'upgrade';
};

//Like setSelection, but only a single item of this type (provModel) may be in the basket.
//Adding one therefore removes any other item of the same type that is already selected.
window.setSelectionUnique = function setSelectionUnique( elementId, provModel, unSelectedClass, selectedClass ) {
    const pcid = getPCIDFromString( elementId );
    const itemInBasket = findInBasket( pcid );

    if ( itemInBasket !== null ) {
        //The add event for this item is already in the basket - toggle it off.
        //Refuse if another basket selection depends on it (remove that first).
        const ownedIds = JSON.parse( sessionStorage.getItem( 'pa_customerProductIds' ) );
        const ownedChannelIds = JSON.parse( sessionStorage.getItem( 'pa_customerChannelIds' ) );
        if ( ! allowRemove( pcid, { ...ownedIds, ...ownedChannelIds } ) ) {
            window.parent.notifyError( 'Produktet kan ikke fjernes. Det kræves af et andet produkt i kurven.' );
            return false;
        }
        //Dropped, not decremented: see dropSelections().
        window.dropSelections( ( line ) => String( line.id ) === String( pcid ) && line.action !== 'remove' );
        jQuery( "#" + elementId ).removeClass( selectedClass ).addClass( unSelectedClass );
        return;
    }

    //Item not selected yet - we want to add it.
    //Does this product require other products
    const customerProductIds = JSON.parse( sessionStorage.getItem( 'pa_customerProductIds' ) );
    const customerChannelIds = JSON.parse( sessionStorage.getItem( 'pa_customerChannelIds' ) );
    if ( ! allowAdd( pcid, { ...customerProductIds, ...customerChannelIds } ) ) {
        window.parent.notifyError( 'Produktet kan ikke bestilles. Det kræver andre aktive produkter.' );
        return false;
    }

    //Only one item of this type is allowed - remove any other SELECTION of
    //the same provModel first. 'remove' lines are cancellations of owned
    //products, not selections — evicting them would silently drop the
    //customer's cancellation. String() on both ids: the click path derives a
    //string pcid while other writers store numbers.
    const isOtherSelection = ( line ) =>
        line && line.provModel == provModel && line.action !== 'remove' && String( line.id ) !== String( pcid );

    //One pass, one write, one event.
    //
    //This used to be a while-loop that called removeFromBasket() and then asked
    //the basket again. removeFromBasket does not remove a line - it subtracts
    //one from its quantity and keeps the line while quantity stays above zero -
    //so a line added twice took two rounds, and each round fired
    //pa_basket_update. That is the counter flickering. Worse: if the id did not
    //match, removeFromBasket wrote nothing, the same line was found again, and
    //the loop never ended.
    //
    //Selections are dropped outright here. A subscription is not a quantity:
    //nobody has two internet connections on one address, and "deselect" means
    //gone, not one fewer.
    window.dropSelections( isOtherSelection ).forEach( ( line ) => {
        //The other card's element id: same prefix, different pcid.
        const otherId = elementId.slice( 0, elementId.length - pcid.length ) + line.id;
        jQuery( "#" + otherId ).removeClass( selectedClass ).addClass( unSelectedClass );
    } );

    const action = resolveSubscriptionAction( pcid, provModel );
    //Only mark the card when the basket was actually written (see setSelection).
    if ( addToBasket( pcid, provModel, action ) === false ) {
        return false;
    }
    jQuery( "#" + elementId ).removeClass( unSelectedClass ).addClass( selectedClass );
};

window.findMixInBasket = function findMixInBasket( mixProductConfs ) {
    for ( const p in mixProductConfs ) {
        const bItem = findInBasket( p );
        if ( bItem != null ) {
            return bItem;
        }
    }

    return null;
};

window.getMixProductConfs = function getMixProductConfs() {
    const prds = JSON.parse( sessionStorage.getItem( 'pa_availableProducts' ) );
    const mps = new Object();
    for ( const p in prds ) {
        //Sparse catalog entries can lack parameters entirely.
        if ( String( prds[ p ].parameters || '' ).search( 'packetmix' ) >= 0 ) {
            mps[ p ] = prds[ p ];
        }
    }

    return mps;
};

//To be used just before submitting mix config
window.saveSelectedMixChannels = function saveSelectedMixChannels() {
    //If no mix in basket - return
    const mixProduct = findMixInBasket( getMixProductConfs() );
    if ( mixProduct == null ) {
        return false;
    }

    const selectedSlugs = JSON.parse( sessionStorage.getItem( 'pa_selectedSlugs' ) );
    const mixInfo = JSON.parse( sessionStorage.getItem( 'pa_mixCounter' ) );
    const customerProducts = JSON.parse( sessionStorage.getItem( 'pa_customerProducts' ) );
    const pointValues = JSON.parse( sessionStorage.getItem( 'pa_pointValues' ) );

    let configStr = "chosentvchannels:";
    let channelCount = 0;
    for ( const i in selectedSlugs ) {
        if ( selectedSlugs[ i ] != 'M' ) {
            channelCount += pointValues[ i ];
            //If a channel is deselected and selected again it changes to 'edited' - But that does not mean it requires a new expiry date
            if ( selectedSlugs[ i ] == 'edited' ) {
                selectedSlugs[ i ] = getActiveChannelExpiry( i, customerProducts, mixInfo );
            }

            const theDateTime = ( ( selectedSlugs[ i ] == 'edited' ) || ( selectedSlugs[ i ] == 'D' ) ) ? new Date( parseInt( mixInfo.ChannelLockDays ) * 24 * 60 * 60000 + Date.now() ) : new Date( selectedSlugs[ i ] );
            configStr += i + "\$" + Math.round( theDateTime.getTime() / 1000 ) + ",";
        }
    }

    //If correct number of channels are selected - generate new config string
    if ( mixInfo != null ) {
        if ( channelCount <= mixInfo.size ) {
            configStr = configStr.substring( 0, configStr.length - 1 );

            //We need to see if unrelated stuff is present in the products config
            //Don't want to remove that
            const customerProducts = JSON.parse( sessionStorage.getItem( 'pa_customerProducts' ) );
            let configSet = false;
            for ( const c in customerProducts ) {
                if ( customerProducts[ c ].productConf.id == mixInfo.pcid ) {
                    mergeConfig( customerProducts[ c ].options, configStr, mixInfo.pcid );
                    configSet = true;
                    break;
                }
            }

            if ( ! configSet ) {
                mergeConfig( "", configStr, mixInfo.pcid );
            }
        } else {
            //Fejlmeddelelse
            window.parent.notifyError( 'Der er valgt for mange kanaler.' );
        }
    }
};

window.getActiveChannelExpiry = function getActiveChannelExpiry( slug, customerProducts, mixInfo ) {
    for ( const i in customerProducts ) {
        if ( customerProducts[ i ].productConf.id == mixInfo.pcid ) {
            if ( ( customerProducts[ i ].options.search( ':' + slug + '\\$' ) > 0 ) || ( customerProducts[ i ].options.search( ',' + slug + '\\$' ) > 0 ) ) {
                return new Date( Date.now() - 86400000 );
            }
        }
    }

    return 'edited';
};

window.mergeConfig = function mergeConfig( config, mixConfig, pcid ) {
    const configItems = config.split( ";" );
    const newConfig = [];
    newConfig.push( mixConfig );

    for ( const n in configItems ) {
        if ( configItems[ n ].search( 'chosentvchannels' ) != 0 ) {
            newConfig.push( configItems[ n ] );
        }
    }

    const basket = getBasket();
    //Update basket
    if ( basket != null ) {
        let changed = false;
        for ( const i in basket ) {
            if ( basket[ i ].id == pcid ) {
                basket[ i ].parameters = newConfig.join( ';' );
                changed = true;
            }
        }
        if ( changed ) {
            sessionStorage.setItem( "pa_basket", JSON.stringify( basket ) );
            window.dispatchEvent( new Event( 'pa_basket_update' ) );
        }
    }
};

window.checkConditions = function checkConditions() {
    let reply = true;
    jQuery( ".conditions_check" ).each( function() {
        if ( jQuery( this ).is( ":checked" ) == false && reply ) {
            window.parent.notifyError( "Alle vilkår skal godkendes" );
            reply = false;
        }
    } );
    return reply;
};

window.makeApiRequest = function makeApiRequest( method = 'GET', endpoint, data = null, successCallback, errorCallback = null ) {
    const token = localStorage.getItem( 'customertoken' );
    const isMaster = sessionStorage.getItem( 'isMaster' );
    const baseUrl = JQUERY_VARS.restUrl;

    // Construct URL with token and master parameters if token exists
    let url = `${ baseUrl }${ endpoint }`;
    if ( token ) {
        const separator = url.includes( '?' ) ? '&' : '?';
        url = `${ url }${ separator }token=${ token }&is-master=${ isMaster }`;
    }
    url = addNonce( url );

    // Set up request configuration
    const config = {
        type: method,
        url,
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        success( response ) {
            // Only update token expiration if we have a token
            if ( token ) {
                localStorage.setItem( 'tokenExpire', Math.floor( Date.now() / 1000 ) + 900 );
            }

            // Handle success
            if ( successCallback ) {
                successCallback( response );
            }
        },
        error( xhr, status, error ) {
            // Handle specific HTTP errors
            if ( xhr.status == 401 ) {
                window.parent.notifyError( "Din session er udløbet. Log venligst ind igen." );
                sessionStorage.clear();
                localStorage.clear();
                goToLogin();
            } else if ( xhr.status == 403 ) {
                window.parent.notifyError( "Du har ikke adgang til denne funktion." );
            } else if ( errorCallback ) {
                // Use custom error callback if provided, otherwise show generic error
                errorCallback( xhr, status, error );
            } else {
                window.parent.notifyError( "Der skete en fejl. Prøv igen." );
            }
        },
        fail( jqXHR, textStatus, errorThrown ) {
            console.error( 'Request failed:', textStatus, errorThrown );
            window.parent.notifyError( "Forbindelsen til serveren fejlede. Tjek din internetforbindelse og prøv igen." );
        },
    };

    // Add data based on method
    if ( method == 'GET' ) {
        config.data = data;
    } else if ( data ) {
        config.data = JSON.stringify( data );
    }

    jQuery.ajax( config );
};
